import { LinkButton } from '#components/atoms/buttons/link-button/LinkButton.tsx';
import { ConfirmButtonGroup } from '#components/patterns/confirmations/confirm-button-group/ConfirmButtonGroup.tsx';
import { Modal, ModalBody, ModalFooter, ModalHeader } from '#components/patterns/modal/index.ts';

type Props = {
  onClose: () => void;
  providersLimit: number;
};

export function TooManyOidcProvidersModal({ onClose, providersLimit }: Props) {
  return (
    <Modal isOpen={true} onClose={onClose}>
      <ModalHeader>Account limit reached</ModalHeader>

      <ModalBody>
        <p className="p">
          You’ve reached the maximum limit of 1 admin and {providersLimit} endpoint SSO providers. Please delete unused
          providers before adding more, or reach out to support to request additional providers.
        </p>
      </ModalBody>
      <ModalFooter>
        <ConfirmButtonGroup
          variant="right"
          primaryButton={
            <LinkButton variant="primary" to="/settings/sso?tab=endpoint">
              Close
            </LinkButton>
          }
          secondaryButton={
            <LinkButton variant="link" to="/support/contact">
              Contact us
            </LinkButton>
          }
        />
      </ModalFooter>
    </Modal>
  );
}
